var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash-2 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 6.0625H5H21",
    stroke: "#C80036",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8 6.0625V4.0625C8 3.53207 8.21071 3.02336 8.58579 2.64829C8.96086 2.27321 9.46957 2.0625 10 2.0625H14C14.5304 2.0625 15.0391 2.27321 15.4142 2.64829C15.7893 3.02336 16 3.53207 16 4.0625V6.0625M19 6.0625V20.0625C19 20.5929 18.7893 21.1016 18.4142 21.4767C18.0391 21.8518 17.5304 22.0625 17 22.0625H7C6.46957 22.0625 5.96086 21.8518 5.58579 21.4767C5.21071 21.1016 5 20.5929 5 20.0625V6.0625H19Z",
    stroke: "#C80036",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10 11.0625V17.0625",
    stroke: "#C80036",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14 11.0625V17.0625",
    stroke: "#C80036",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.d449e825228ed195a6f9b6ea454448f7.svg";
export { ForwardRef as ReactComponent };